"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiTabOverrides = function (_a) {
    var _b;
    var breakpoints = _a.breakpoints, palette = _a.palette, spacing = _a.spacing, shape = _a.shape, transitions = _a.transitions, typography = _a.typography;
    var borderBottomWidth = 2;
    return {
        root: __assign(__assign({}, typography.body1), (_b = { padding: spacing(2) + "px " + spacing(3) + "px " + (spacing(2) -
                    borderBottomWidth) + "px", borderBottom: borderBottomWidth + "px solid " + palette.divider, borderTopLeftRadius: shape.borderRadius, borderTopRightRadius: shape.borderRadius, minWidth: undefined, minHeight: undefined, textTransform: undefined, transition: transitions.create(["background-color", "box-shadow", "color"], {
                    duration: transitions.duration.short,
                }), "&:hover": {
                    backgroundColor: palette.action.hover,
                }, "&.Mui-focusVisible": {
                    backgroundColor: palette.action.focus,
                    boxShadow: "inset 1px 1px 0 0 " + palette.text.primary + ", inset -1px 0 0 0 " + palette.text.primary,
                }, "&:active": {
                    backgroundColor: palette.action.active,
                } }, _b[breakpoints.up("sm")] = {
            minWidth: undefined,
        }, _b)),
        textColorInherit: {
            opacity: undefined,
            color: palette.text.secondary,
            "&$selected": {
                color: palette.text.primary,
            },
        },
    };
};
//# sourceMappingURL=MuiTab.js.map